<template>
  <div
    ref="kt_modal_upgrade_plan"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade"
    data-bs-keyboard="false"
    v-modal-drag
    tabindex="-1"
    style="z-index: 1051"
    id="kt_modal_upgrade_plan"
  >
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content rounded">
        <div class="modal-header justify-content-end border-0 pb-0">
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body pt-0 pb-15 px-5 px-xl-20">
          <div class="mb-13 text-center">
            <h1 class="mb-3">Atualizar Plano</h1>
            <div class="text-gray-400 fw-semobold fs-5">
              Se precisar de mais informações, verifique as
              <a
                @click="this.modalUpgradePlanObservacoes(true)"
                class="btn btn-link link-primary fw-bold"
                >Diretrizes de Preços</a
              >.
            </div>
          </div>
          <div class="d-flex flex-column">
            <div class="row mt-10">
              <div class="col-lg-6 mb-10 mb-lg-0">
                <div class="nav flex-column">
                  <template v-for="(plan, index) in plans" :key="index">
                    <div
                      v-if="
                        (plan.id === 0 && this.tipo_pacote_atual === 0) ||
                        plan.id > 0
                      "
                      @click="selected = plan.title"
                      :id="`nav-link_${index}`"
                      class="nav-link btn btn-outline btn-outline-dashed btn-color-dark d-flex flex-stack text-start p-6 nav-link-upgrade-plan"
                      :class="[
                        index !== plans.length - 1 && 'mb-6',
                        plan.default && 'active',
                        !plan.custom && 'btn-active btn-active-primary',
                      ]"
                      data-bs-toggle="tab"
                      :data-bs-target="`#kt_upgrade_plan_${index}`"
                    >
                      <div class="d-flex align-items-center me-2">
                        <div
                          class="form-check form-check-custom form-check-solid form-check-success me-6"
                        >
                          <input
                            class="form-check-input"
                            type="radio"
                            name="plan"
                            :value="plan.title"
                            :checked="selected === plan.title"
                          />
                        </div>
                        <div class="flex-grow-1">
                          <h2
                            class="d-flex align-items-center fs-2 fw-bold flex-wrap"
                          >
                            {{ plan.title }}
                            <span
                              v-if="plan.label"
                              class="badge ms-2 fs-7"
                              :class="[
                                plan.label === `Atual`
                                  ? `badge-light-primary`
                                  : `badge-light-success`,
                              ]"
                              >{{ plan.label }}</span
                            >
                          </h2>
                          <div class="fw-semobold opacity-50">
                            {{ plan.subTitle }}
                          </div>
                        </div>
                      </div>
                      <div class="ms-5">
                        <button
                          v-if="plan.custom"
                          class="btn btn-sm btn-primary"
                        >
                          Contate-nos
                        </button>
                        <template v-else-if="plan.priceMonth === `?`">
                          <span class="fs-4 fw-bold">
                            {{ "à definir" }}
                          </span>
                          <span class="fs-7 opacity-50"
                            >/
                            <span data-kt-element="period">Mês</span>
                          </span>
                        </template>
                        <template v-else>
                          <span class="mb-2">R$</span>

                          <span class="fs-3x fw-bold">
                            {{ plan.priceMonth }}
                          </span>
                          <span class="fs-7 opacity-50"
                            >/
                            <span data-kt-element="period">Mês</span>
                          </span>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="tab-content rounded h-100 bg-light p-10">
                  <template v-for="(plan, index) in plans" :key="index">
                    <div
                      v-if="!plan.custom"
                      :class="[plan.default && 'show active']"
                      class="tab-pane fade tab-pane-upgrade-plan"
                      :id="`kt_upgrade_plan_${index}`"
                    >
                      <div class="pb-5">
                        <h2 class="fw-bold text-dark">
                          {{ "O que há no Plano " + plan.title + "?" }}
                        </h2>
                        <div class="text-gray-400 fw-semobold">
                          {{ plan.description }}
                        </div>
                      </div>
                      <div class="pt-1">
                        <template
                          v-for="(feature, i) in plan.features"
                          :key="i"
                        >
                          <div
                            :class="[i !== plan.features.length - 1 && 'mb-7']"
                            class="d-flex align-items-center"
                          >
                            <template v-if="feature.supported">
                              <span
                                class="fw-semobold fs-5 text-gray-700 flex-grow-1"
                              >
                                {{ feature.title }}
                              </span>
                              <span
                                class="svg-icon svg-icon-1 svg-icon-success"
                              >
                                <inline-svg
                                  src="media/icons/duotune/general/gen043.svg"
                                />
                              </span>
                            </template>
                            <template v-else>
                              <span
                                class="fw-semobold fs-5 text-gray-400 flex-grow-1"
                              >
                                {{ feature.title }}
                              </span>
                              <span class="svg-icon svg-icon-1">
                                <inline-svg
                                  src="media/icons/duotune/general/gen040.svg"
                                />
                              </span>
                            </template>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-center flex-row-fluid pt-12">
            <button
              type="button"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              v-if="this.adicionar"
              @click="procurarRevenda()"
              type="button"
              class="btn btn-primary"
            >
              Solicitar
            </button>
          </div>
          <div v-if="this.solicitacoes.length > 0" class="col-12 mt-10">
            <div class="mb-10 fv-row">
              <h4 class="text-primary ms-4">Solicitações em andamento</h4>
              <div class="table-responsive">
                <table
                  class="table table-hover table-rounded table-striped border gy-2 gs-7"
                >
                  <tr
                    class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0"
                    role="row"
                  >
                    <th>Plano Solicitado</th>
                    <th class="ps-7">Revenda</th>
                    <th class="text-end">AÇÕES</th>
                  </tr>
                  <tbody>
                    <tr
                      v-for="atualizacaoPlano in this.solicitacoes"
                      :key="atualizacaoPlano"
                    >
                      <td class="align-middle fw-bold text-primary">
                        {{
                          this.plans[atualizacaoPlano.tipo_pacote_solicitado]
                            .title
                        }}
                      </td>
                      <td class="align-middle min-w-150px">
                        {{ atualizacaoPlano.Revenda.nome + " - " }}
                        {{ atualizacaoPlano.Revenda.telefone + " " }}
                        {{ atualizacaoPlano.Revenda.fax }}
                      </td>
                      <td class="align-middle min-w-50px text-end">
                        <button
                          v-if="this.excluir"
                          @click="this.cancelarSolicitacao(atualizacaoPlano)"
                          class="btn btn-sm btn-light-danger"
                        >
                          Cancelar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirUpgradePlanObservacoes" class="modal-overlay">
    <div
      ref="kt_modal_upgrade_plan_observacoes"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_upgrade_plan_observacoes"
    >
      <div class="modal-dialog modal-md modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title d-flex align-items-center">
              <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                <inline-svg src="media/icons/duotune/general/gen045.svg" />
              </span>
              <h3 class="fw-bold m-0 text-gray-800">Diretrizes de Preços</h3>
            </div>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="modalUpgradePlanObservacoes(false)"
            >
              <span class="svg-icon svg-icon-1 svg-icon lh-0">
                <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-5">
            <span
              v-html="diretrizes"
              class="fw-semobold fs-5 text-gray-400 flex-grow-1"
            >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <RevendaModal
    v-if="exibirModalRevenda"
    :contato="true"
    @exibirModalRevenda="modalRevenda"
    @selecionarRevenda="selecionarRevenda"
  ></RevendaModal>
  <EmitentePacoteModal
    ref="emitentePacoteModal"
    v-if="exibirModalPacoteEmitente"
    :emitentePacote="this.atualizacaoPlano.Emitente"
    :modal="true"
    :exibirTelaResumida="true"
    :isRevenda="this.isRevenda"
    :errosValidacao="this.errosValidacao"
    @exibirModalEmitentePacote="modalPacoteEmitente"
    @confirmarEmitentePacote="confirmarAtualizacaoPlano"
  ></EmitentePacoteModal>
  <OpcoesPagamentoModal
    v-if="exibirModalOpcoesPagamento"
    :id="this.idLicencaFatura"
    @exibirOpcoesPagamentoModal="exibirOpcoesPagamentoModal"
    @confirmarOpcoesPagamentoModal="confirmarOpcoesPagamentoModal"
  >
  </OpcoesPagamentoModal>
  <LoadingModal
    :nomeRef="'loadingModalUpgradePlan'"
    mensagem=""
    v-if="this.loading === true"
  ></LoadingModal>
</template>

<script>
import { ref } from "vue";
import { mapState } from "vuex";
import {
  hideModalId,
  hideModal,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import RevendaModal from "@/views/revenda/revenda/RevendaModal.vue";
import EmitentePacoteModal from "@/views/empresas/EmitentePacoteModal.vue";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import OpcoesPagamentoModal from "@/views/licencarecebivel/OpcoesPagamentoModal.vue";

const atualizacaoPlanoInicializada = {
  id: 0,
  id_empresa: 0,
  id_revenda: 0,
  id_usuario: 0,
  tipo_pacote_atual: 0,
  tipo_pacote_solicitado: 0,
  data_finalizacao: null,
  finalizado: "0",
  qtd_pdv_solicitado: 0,
  qtd_terminais_solicitado: 0,
  valor_contrato_solicitado: 0,
  cancelado: "0",
  Emitente: {
    tipo_pacote: 0,
    qtd_pdv: 0,
    qtd_terminais: 0,
    valor_contrato: 0,
  },
};

export default {
  name: "upgrade-plan-modal",
  components: {
    RevendaModal,
    EmitentePacoteModal,
    LoadingModal,
    OpcoesPagamentoModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    confirmarOpcoesPagamentoModal() {
      this.exibirOpcoesPagamentoModal(false);
      hideModal(this.$refs.kt_modal_upgrade_plan);
    },
    async exibirModalPagamento(data) {
      this.idLicencaFatura = data.id;
      this.exibirOpcoesPagamentoModal(true);
    },
    exibirOpcoesPagamentoModal(exibir) {
      this.exibirModalOpcoesPagamento = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_opcoes_pagamento_modal",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_opcoes_pagamento_modal");
          },
          /*close*/ () => {
            this.exibirOpcoesPagamentoModal(false);
          }
        );
      }
    },
    modalPacoteEmitente(exibir) {
      this.exibirModalPacoteEmitente = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_emitente_pacote",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_emitente_pacote");
          },
          /*close*/ () => {
            this.modalPacoteEmitente(false);
          }
        );
      }
    },
    async cancelarSolicitacao(atualizacaoPlano) {
      await this.$swal.showQuestionAlert(
        "Deseja cancelar a solicitação atual?",
        async (alert) => {
          if (alert.isConfirmed) {
            await this.exibirModalLoading(true);
            try {
              var ret = await this.$store.dispatch(
                "atualizacaoPlano/postAtualizacaoPlanoCancelarPlano",
                atualizacaoPlano.id
              );
              if (ret.Success === true) {
                await this.exibirModalLoading(false);
                await this.$swal.showSuccessAlert(
                  "Solicitação cancelada com sucesso!",
                  async (alert) => {
                    await this.carregarAtualizacaoPlano();
                  }
                );
              }
            } catch (error) {
              await this.exibirModalLoading(false);
              await this.$swal.showInvalidAlert(error.Message);
            }
          }
        }
      );
    },
    async gerarLicencaRecebivel(data) {
      let vencimento = new Date();
      vencimento.setDate(vencimento.getDate() + 5);

      var licencaFatura = {
        id: 0,
        descricao: "Migração de Plano",
        emissao: new Date(),
        vencimento: vencimento,
        pagamento: null,
        fatura: null,
        valor: data.valor_contrato_solicitado,
        valor_recebido: 0,
        guid: this.$utils.generateUuidv4(),
        guid_fatura: "",
        observacoes: "",
        id_emitente: data.id_empresa,
        id_distribuidor_master: null,
        id_distribuidor: null,
        id_revenda: null,
        Emitente: null,
        DistribuidorMaster: null,
        Distribuidor: null,
        Revenda: null,
        licenca_uso: "0",
        id_atualizacao_plano: data.id,
      };

      let formData = this.$utils.convertModelToFormData(licencaFatura);

      try {
        var ret = await this.$store.dispatch(
          "licencaRecebivel/postLicencaRecebivel",
          formData
        );
        if (ret.Success === true) {
          await this.exibirModalLoading(false);
          await this.$swal.showSuccessAlert(
            "Solicitação enviada com sucesso! Agora é só escolher a melhor forma de pagamento!",
            (alert) => {
              this.exibirModalPagamento(ret.Data);
            }
          );
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        await this.$swal.showInvalidAlert(
          "Não foi possível concluir sua solicitação, erro na geração da cobrança, por favor tente novamente!"
        );
      }
    },
    async confirmarAtualizacaoPlano(emitentePacote) {
      this.atualizacaoPlano.tipo_pacote_solicitado = emitentePacote.tipo_pacote;
      this.atualizacaoPlano.qtd_pdv_solicitado = emitentePacote.qtd_pdv;
      this.atualizacaoPlano.qtd_terminais_solicitado =
        emitentePacote.qtd_terminais;
      this.atualizacaoPlano.valor_contrato_solicitado =
        emitentePacote.valor_contrato;
      this.atualizacaoPlano.Emitente = null;

      if (
        this.user.User.Emitente.Revenda.cnpj === "00221619000126" &&
        this.atualizacaoPlano.tipo_pacote_solicitado > 1
      ) {
        await this.$swal.showInfoAlert(
          "Estamos quase lá, basta selecionar o revendedor mais próximo de sua localidade, assim você poderá conferir nossos planos e valores com maior facilidade e sem compromisso!",
          (alert) => {
            hideModalId("kt_modal_emitente_pacote");
            this.modalPacoteEmitente(false);
            this.modalRevenda(true);
          }
        );
      } else {
        hideModalId("kt_modal_emitente_pacote");
        this.modalPacoteEmitente(false);
        await this.exibirModalLoading(true);
        var ret = await this.confirmarSolicitacao(
          this.user.User.Emitente.Revenda.id
        );
        if (ret.Success === true) {
          await this.carregarAtualizacaoPlano();

          if (
            this.user.User.Emitente.Revenda.cnpj === "00221619000126" &&
            ret.Data.tipo_pacote_solicitado === 1
          ) {
            await this.gerarLicencaRecebivel(ret.Data);
          } else {
            await this.exibirModalLoading(false);
            await this.$swal.showSuccessAlert(
              "Solicitação enviada com sucesso! Agora é só aguardar que logo o revendedor entrará em contato com você!",
              (alert) => {
                hideModal(this.$refs.kt_modal_upgrade_plan);
              }
            );
          }
        }
      }
    },
    async confirmarSolicitacao(id_revenda) {
      var result = {
        Success: false,
        Data: null,
      };
      this.atualizacaoPlano.id_revenda = id_revenda;
      try {
        var ret = await this.$store.dispatch(
          "atualizacaoPlano/postAtualizacaoPlano",
          this.atualizacaoPlano
        );
        if (ret.Success === true) {
          result.Success = true;
          result.Data = ret.Data;
          return result;
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        await this.$swal.showInvalidAlert(
          "Não foi possível enviar sua solicitação, por favor tente novamente!"
        );
      }

      return result;
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async exibirModalLoading(exibir, callback) {
      if (exibir === true) {
        this.loading = true;
        getOrCreateInstanceModal(
          "loadingModalUpgradePlan",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalUpgradePlan", () => {
          this.loading = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    async selecionarRevenda(revenda) {
      await this.exibirModalLoading(true);
      var ret = await this.confirmarSolicitacao(revenda.id);
      if (ret.Success === true) {
        var pacoteSolicitado = this.plans.find(
          (plan) => plan.title === this.selected
        );

        this.tagsEmails.push(revenda.email);
        this.subject =
          "Solicitação de Atualização de Plano - Gateway Sistemas Web";
        this.message =
          '<h2 style="text-align:center">Gateway Sistemas</h2>' +
          '<span style=color:#777777><h1 style="text-align:center">Temos uma solicitação para você!</h1></span>' +
          "<span style=color:#FFFFFF>" +
          '<div style="background:#212529;border:4px solid #E0E2EA;padding:20px 20px;width:75%;margin: auto;">' +
          '<p style="text-align:center"><span style="font-size:18px">Sua revenda foi selecionada pela empresa ' +
          this.user.User.Emitente.nome +
          " para uma atualização de plano.</span></p>" +
          '<p style="text-align:center"><span style="font-size:18px">Plano atual: ' +
          this.plans[this.tipo_pacote_atual].title +
          "</span></p>" +
          '<p style="text-align:center"><span style="font-size:18px">Solicitado por: ' +
          this.user.User.nome +
          "</span></p>" +
          '<p style="text-align:center"><span style="font-size:18px">Telefone/Celular: ' +
          this.user.User.Emitente.telefone +
          " " +
          (this.user.User.Emitente.fax ? this.user.User.Emitente.fax : "") +
          "</span></p>" +
          '<p style="text-align:center"><span style="font-size:18px">Email: ' +
          this.user.User.Emitente.email +
          "</span></p>" +
          "<hr />" +
          '<p style="text-align:center"><span style="font-size:22px"><strong> Plano solicitado: ' +
          pacoteSolicitado.title +
          "</strong></span></p>" +
          "<hr />" +
          '<div style="page-break-after: always"><span style="display:none">&nbsp;</span></div>' +
          '<p style="text-align:center"><span style="font-size:18px">Seu cliente aguarda anciosamente pelo seu contato, não deixe-o esperando, ofereça sua proposta de atualização de plano e conquiste cada vez mais clientes!</span></p>' +
          '<p><br><span style="font-size:14px">Não faz parte de nossa equipe de revendedores autorizados? Por favor ignore este e-mail. Obrigado.</span></p>' +
          "</div>" +
          '<p style="text-align:center"><br><img src=https://uploaddeimagens.com.br/images/003/404/848/original/Assinatura.png?1630279225 >';

        var email = {
          emails: this.tagsEmails,
          celular: "",
          titulo: this.subject,
          mensagem: this.message,
          anexos: this.files,
        };

        try {
          var response = await this.$store.dispatch(
            "compartilhamento/enviarEmail",
            email
          );
          if (response.Success === true) {
            await this.carregarAtualizacaoPlano();
            await this.exibirModalLoading(false);
            await this.$swal.showSuccessAlert(
              "Solicitação enviada com sucesso! Agora é só aguardar que logo o revendedor selecionado entrará em contato com você!",
              (alert) => {
                hideModal(this.$refs.kt_modal_upgrade_plan);
              }
            );
          }
        } catch (error) {
          await this.exibirModalLoading(false);
          await this.$swal.showInvalidAlert(
            "Não foi possível enviar sua solicitação, por favor tente novamente!"
          );
        }
      }
      await this.exibirModalLoading(false);
    },
    modalRevenda(exibir) {
      this.exibirModalRevenda = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_revenda_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisar");
          },
          /*close*/ () => {
            this.modalRevenda(false);
          }
        );
      }
    },
    async procurarRevenda() {
      if ((await this.validar()) === true) {
        var pacoteSolicitado = this.plans.find(
          (plan) => plan.title === this.selected
        );

        this.atualizacaoPlano = JSON.parse(
          JSON.stringify(atualizacaoPlanoInicializada)
        );

        this.atualizacaoPlano.id_empresa = this.user.User.id_empresa;
        this.atualizacaoPlano.id_revenda = this.user.User.Emitente.Revenda.id;
        this.atualizacaoPlano.id_usuario = this.user.User.id;
        this.atualizacaoPlano.tipo_pacote_atual = this.tipo_pacote_atual;

        this.atualizacaoPlano.Emitente.tipo_pacote = pacoteSolicitado.id;
        this.atualizacaoPlano.Emitente.qtd_pdv =
          this.user.User.Emitente.qtd_pdv;
        this.atualizacaoPlano.Emitente.qtd_terminais =
          this.user.User.Emitente.qtd_terminais;
        this.atualizacaoPlano.Emitente.valor_contrato =
          this.user.User.Emitente.valor_contrato;
        this.isRevenda =
          this.user.User.Emitente.Revenda.cnpj === "00221619000126" &&
          pacoteSolicitado.id <= 1
            ? false
            : true;
        this.modalPacoteEmitente(true);
        setTimeout(() => {
          this.$refs.emitentePacoteModal.calcularValorPacote();
        }, 500);
      }
    },
    async validar() {
      let result = true;
      var pacote = this.plans.find((plan) => plan.title === this.selected);
      if (this.tipo_pacote_atual === pacote.id) {
        await this.$swal.showInvalidAlert(
          "É necessário selecionar um plano diferente do plano atual!",
          (alert) => {
            result = false;
          }
        );
      }

      if (this.solicitacoes.length > 0) {
        await this.$swal.showInvalidAlert(
          "Existe uma solicitação em andamento, cancele a solicitação atual antes de continuar!",
          (alert) => {
            result = false;
          }
        );
      }

      return result;
    },
    modalUpgradePlanObservacoes(exibir) {
      this.exibirUpgradePlanObservacoes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_upgrade_plan_observacoes",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_upgrade_plan_observacoes");
          },
          /*close*/ () => {
            this.modalUpgradePlanObservacoes(false);
          }
        );
      }
    },
    tabFocus(index) {
      this.selected = this.plans[index].title;
      this.plans[index].default = true;
      var idTab = `nav-link_${index}`;
      var idPage = `kt_upgrade_plan_${index}`;
      if (
        document.getElementById(idTab) != null &&
        document.getElementById(idPage) != null
      ) {
        var tabs = document.getElementsByClassName("nav-link-upgrade-plan");
        for (var i = 0; i < tabs.length; i++) {
          tabs[i].classList.remove("active");
        }

        var pages = document.getElementsByClassName("tab-pane-upgrade-plan");
        for (var y = 0; y < pages.length; y++) {
          pages[y].classList.remove("show");
          pages[y].classList.remove("active");
        }

        document.getElementById(idTab).classList.add("active");
        document.getElementById(idPage).classList.add("show");
        document.getElementById(idPage).classList.add("active");
      }
    },
    async carregarAtualizacaoPlano() {
      this.solicitacoes = [];
      try {
        var ret = await this.$store.dispatch(
          "atualizacaoPlano/getAtualizacaoPlanoOData",
          "?&$expand=Revenda&$filter=finalizado eq '0' and cancelado eq '0' and id_empresa eq " +
            this.user.User.id_empresa
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.solicitacoes = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.AtualizacaoPlano.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.AtualizacaoPlano.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
  },
  async mounted() {
    if (this.user) {
      this.plans =
        this.user.User.Emitente.Revenda.cnpj === "00221619000126"
          ? this.plansGateway
          : this.plansRevenda;
      this.verificarRestricoes();
      this.carregarAtualizacaoPlano();
      this.tipo_pacote_atual = this.user.User.Emitente.tipo_pacote;
      this.plans[this.tipo_pacote_atual].label = "Atual";
      this.tabFocus(this.tipo_pacote_atual);

      this.diretrizes = `<h1 style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color:rgb(24, 28, 50);font-family:Inter, Helvetica, &quot;sans-serif&quot;;font-size:1.75rem;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;letter-spacing:normal;line-height:1.2;margin-bottom:0.5rem;margin-top:0px;orphans:2;outline:0px;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    Gateway Sistemas
</h1>
<h1 style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color:rgb(24, 28, 50);font-family:Inter, Helvetica, &quot;sans-serif&quot;;font-size:1.75rem;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;letter-spacing:normal;line-height:1.2;margin-bottom:0.5rem;margin-top:0px;orphans:2;outline:0px;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    <span style="box-sizing:border-box;font-size:14pt;line-height:19.9733px;scrollbar-color:var(--kt-scrollbar-color) transparent;scrollbar-width:thin;"><strong><o:p style="box-sizing:border-box;"></o:p></strong></span>
</h1>
<p style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color:rgb(24, 28, 50);font-family:Inter, Helvetica, &quot;sans-serif&quot;;font-size:13px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    O nosso sistema é distribuído para todo o Brasil através de nossos revendedores.
</p>
<p style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color:rgb(24, 28, 50);font-family:Inter, Helvetica, &quot;sans-serif&quot;;font-size:13px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    Permitimos que ao solicitar uma atualização de plano você possa selecionar o revendedor mais próximo de sua localidade, assim você poderá conferir nossos planos e valores com maior facilidade e sem compromisso.
</p>
<p style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color:rgb(24, 28, 50);font-family:Inter, Helvetica, &quot;sans-serif&quot;;font-size:13px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    Alguns dos fatores que podem influenciar diretamente no valor do seu plano são:
</p>
<ul style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color:rgb(24, 28, 50);font-family:Inter, Helvetica, &quot;sans-serif&quot;;font-size:13px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    <li>
        Tipo do plano escolhido
    </li>
    <li>
        Quantidade de licenças de terminais ou PDVs
    </li>
</ul>
<p style="-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);box-sizing:border-box;color:rgb(24, 28, 50);font-family:Inter, Helvetica, &quot;sans-serif&quot;;font-size:13px;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;margin-bottom:1rem;margin-top:0px;orphans:2;text-align:start;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">
    Venha parte da empresa que mais se preocupa com o seu negócio, com total suporte e com mensalidades que cabem no seu bolso.<o:p style="box-sizing:border-box;"></o:p>
</p>
<p>
    <br>
    &nbsp;
</p>`;
    }
  },
  setup() {
    const selected = ref("");

    const plansRevenda = [
      {
        id: 0,
        title: "Gratuito",
        subTitle: "Ideal para começar o seu negócio",
        description: "Ideal para começar o seu negócio",
        priceMonth: "0",
        default: false,
        custom: false,
        features: [
          {
            title: "Apenas 1 usuário ativo simultaneamente",
            supported: true,
          },
          {
            title: "Até 5 faturamentos por mês",
            supported: true,
          },
          {
            title: "Consulta com Filtros Avançados",
            supported: false,
          },
          {
            title: "Relatórios Personalizados",
            supported: false,
          },
          {
            title: "Suporte Técnico com a Revenda mais próxima",
            supported: false,
          },
        ],
      },
      {
        id: 1,
        title: "Emissor",
        label: "Melhor Opção",
        subTitle: "Ideal para controle total do seu negócio",
        description: "Ideal para controle total do seu negócio",
        priceMonth: "?",
        default: false,
        custom: false,
        features: [
          {
            title: "Escolha a quantidade usuários ativos simultaneamente",
            supported: true,
          },
          {
            title: "Sem limite de transmissão de NF-e por mês",
            supported: true,
          },
          {
            title: "Consulta com Filtros Avançados",
            supported: true,
          },
          {
            title: "Relatórios Personalizados",
            supported: true,
          },
          {
            title: "Suporte Técnico com a Revenda mais próxima",
            supported: true,
          },
        ],
      },
    ];

    const plansGateway = [
      {
        id: 0,
        title: "Gratuito",
        subTitle: "Ideal para começar o seu negócio",
        description: "Ideal para começar o seu negócio",
        priceMonth: "0",
        default: false,
        custom: false,
        features: [
          {
            title: "Apenas 1 usuário ativo simultaneamente",
            supported: true,
          },
          {
            title: "Até 5 faturamentos por mês",
            supported: true,
          },
          {
            title: "Consulta com Filtros Avançados",
            supported: false,
          },
          {
            title: "Relatórios Personalizados",
            supported: false,
          },
          {
            title: "Suporte Técnico gratuito por 1 mês (via ticket)",
            supported: true,
          },
        ],
      },
      {
        id: 1,
        title: "Emissor",
        label: "Melhor Opção",
        subTitle: "Ideal para controle total do seu negócio",
        description: "Ideal para controle total do seu negócio",
        priceMonth: "100",
        default: false,
        custom: false,
        features: [
          {
            title: "Escolha a quantidade usuários ativos simultaneamente",
            supported: true,
          },
          {
            title: "Sem limite de transmissão de NF-e por mês",
            supported: true,
          },
          {
            title: "Consulta com Filtros Avançados",
            supported: true,
          },
          {
            title: "Relatórios Personalizados",
            supported: true,
          },
          {
            title: "Suporte Técnico Ilimitado",
            supported: true,
          },
        ],
      },
    ];

    return {
      plansGateway,
      plansRevenda,
      selected,
    };
  },
  data() {
    return {
      idLicencaFatura: -1,
      exibirModalOpcoesPagamento: false,
      isRevenda: true,
      atualizacaoPlano: JSON.parse(
        JSON.stringify(atualizacaoPlanoInicializada)
      ),
      errosValidacao: {},
      plans: [],
      adicionar: false,
      excluir: false,
      solicitacoes: [],
      loading: false,
      subject: "",
      message: "",
      tagsEmails: [],
      files: [],
      email: "",
      exibirModalRevenda: false,
      exibirModalPacoteEmitente: false,
      diretrizes: "",
      tipo_pacote_atual: 0,
      exibirUpgradePlanObservacoes: false,
    };
  },
};
</script>

<style></style>
